import React from 'react';
import { Flex, Text, Button } from '@chakra-ui/react';
import { NoMembersStyles } from './styles';

export interface NoMembersMessageProps {
  onButtonClick: () => void;
}

export const NoMembersMessage: React.FC<NoMembersMessageProps> = ({
  onButtonClick,
}) => {
  const { title, text, container } = NoMembersStyles;
  return (
    <Flex direction="column" alignItems="center" sx={container} maxWidth={536}>
      <Text sx={title} data-testid="new-split-empty-list-title">
        No Songwriters
      </Text>
      <Text sx={text} data-testid="new-split-empty-list-message">
        You have no Credited songwriters to add to this Split
      </Text>
      <Button
        sx={{ mt: 6 }}
        onClick={onButtonClick}
        data-testid="new-split-empty-list-button"
      >
        Got it
      </Button>
    </Flex>
  );
};
